/** Легенда территории (референс Legend 1:1 по структуре): категории объектов
 *  площадки, линии маршрута (по дорогам / вне дорог), безопасность.
 *  Сворачивается; на маленьких экранах закрыта по умолчанию. */
import { tr } from '@app/i18n'
import { terraCategory } from '@app/tokens'
import { langTick, legendOpen, venue } from '../state'
import { categoryLabel } from './labels'
import { useDragPanel } from './use-drag'

function presentCategories(): string[] {
  const v = venue.value
  if (!v) return []
  const set = new Set<string>()
  for (const u of v.units) set.add(u.category)
  for (const p of v.pois) set.add(p.category)
  return [...set].slice(0, 8)
}

function catColor(category: string): string {
  return (terraCategory as Record<string, string>)[category] ?? terraCategory.__default
}

export function Legend() {
  langTick.value
  const drag = useDragPanel('legend')
  const cats = presentCategories()
  if (cats.length === 0 || !legendOpen.value) return null

  return (
    <div ref={drag.elRef as never} style={drag.style} class="legend glass">
      <button
        type="button"
        class="legend-head drag-handle"
        onPointerDown={(e) => drag.onDragStart(e as unknown as PointerEvent)}
        onClick={() => {
          if (!drag.wasDragged()) legendOpen.value = false
        }}
      >
        <span class="tech-label">{tr('legend.title')}</span>
        <span aria-hidden="true">▾</span>
      </button>
      <div class="legend-body">
        <p class="legend-section tech-label">{tr('legend.objects')}</p>
        {cats.map((c) => (
          <div key={c} class="legend-row">
            <span class="legend-dot" style={{ background: catColor(c) }} />
            <span>{categoryLabel(c)}</span>
          </div>
        ))}
        <p class="legend-section tech-label">{tr('legend.route')}</p>
        <div class="legend-row">
          <span class="legend-line" />
          <span>{tr('legend.route_network')}</span>
        </div>
        <div class="legend-row">
          <span class="legend-line legend-line-dash" />
          <span>{tr('legend.route_direct')}</span>
        </div>
        <p class="legend-section tech-label">{tr('legend.safety')}</p>
        <div class="legend-row">
          <span class="legend-dot legend-dot-safety" />
          <span>{tr('legend.safety_points')}</span>
        </div>
      </div>
    </div>
  )
}
